import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=a00c9120&scoped=true"
import script from "./DashboardCard.vue?vue&type=script&lang=js"
export * from "./DashboardCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardCard.vue?vue&type=style&index=0&id=a00c9120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00c9120",
  null
  
)

export default component.exports